import {useQuery} from 'react-query'
import api from '../api'

export const useGetUsersQuery = () => {
  return useQuery(['getUsers'], () => api.getUsers(), {
    keepPreviousData: true,
  })
}
